// src/js/modules/portfolio.js
export default function initPortfolioPage() {
    const root = document.querySelector(".page-template-page-portfolio");
    if (!root) return;

    const pills = root.querySelectorAll(".filters-bar .pill");
    const cards = root.querySelectorAll("#portfolio-grid .case-card");
    const line  = root.querySelector(".news-section__line");

    if (!pills.length || !cards.length) return;

    const setActive = (btn) => {
        pills.forEach(p => p.classList.remove("pill--active"));
        btn.classList.add("pill--active");
    };

    const apply = (filter) => {
        let visible = 0;
        cards.forEach(card => {
            const terms = (card.getAttribute("data-terms") || "").split(/\s+/);
            const show = filter === "all" || terms.includes(filter);
            card.style.display = show ? "" : "none";
            if (show) visible++;
        });
        if (line) {
            // допоміжний рефлоу, щоб сітка щільно складалась
            line.style.gap = "16px";
            line.style.justifyContent = (visible === 1) ? "center" : "space-between";
        }
    };

    pills.forEach(btn => {
        btn.addEventListener("click", () => {
            setActive(btn);
            apply(btn.getAttribute("data-filter") || "all");
        });
    });

    // initial
    const active = root.querySelector(".filters-bar .pill.pill--active");
    apply(active ? active.getAttribute("data-filter") : "all");

    // a11y: синхронізуємо aria-selected
    const syncAria = () => {
        pills.forEach(p => p.setAttribute("aria-selected", p.classList.contains("pill--active") ? "true" : "false"));
    };
    root.addEventListener("click", (e) => {
        if (e.target.closest(".pill")) syncAria();
    });
    syncAria();
}
